var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBracketsSquareLightFull(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 640",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#5a8aff",
    d: "M144 96C117.5 96 96 117.5 96 144L96 496C96 522.5 117.5 544 144 544L240 544C248.8 544 256 536.8 256 528C256 519.2 248.8 512 240 512L144 512C135.2 512 128 504.8 128 496L128 144C128 135.2 135.2 128 144 128L240 128C248.8 128 256 120.8 256 112C256 103.2 248.8 96 240 96L144 96zM496 96L400 96C391.2 96 384 103.2 384 112C384 120.8 391.2 128 400 128L496 128C504.8 128 512 135.2 512 144L512 496C512 504.8 504.8 512 496 512L400 512C391.2 512 384 519.2 384 528C384 536.8 391.2 544 400 544L496 544C522.5 544 544 522.5 544 496L544 144C544 117.5 522.5 96 496 96z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBracketsSquareLightFull);
export default __webpack_public_path__ + "static/media/brackets-square-light-full.64beeaebfa4264fd1d9900780e7f52b2.svg";
export { ForwardRef as ReactComponent };